import { MarketingNavTypes } from '@dtx-company/true-common/src/types/appContent'

export const MARKETING_NAV_CONFIG: MarketingNavTypes = {
  desktop: [
    {
      items: [
        {
          fullWidth: false,
          label: 'Flowcode',
          label_subtext: 'Free QR code generator',
          link: 'https://www.flowcode.com/free-qr-code-generator',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Flowpage',
          label_subtext: 'Mobile-first landing pages',
          link: 'https://www.flowcode.com/page',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'FlowcodeTV ',
          label_subtext: 'Make any video interactive',
          link: 'https://www.flowcode.com/industry/tv',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Flowlytics',
          label_subtext: 'Measure performance, gain insights',
          link: 'https://www.flowcode.com/flowcode-insights',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Flowtag',
          label_subtext: 'Easily share your contact info in real life',
          link: 'https://www.flowcode.com/flowtag',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Flowcode Pixel',
          label_subtext: 'Measure the ROI of your offline campaigns',
          link: 'https://www.flowcode.com/tools/flowcode-pixel',
          isExternal: false
        }
      ],
      columns: 3,
      label: 'Products',
      link: '',
      isDense: false,
      isExternal: false
    },
    {
      items: [
        {
          fullWidth: true,
          label: 'Explore All',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'CPG',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/cpg',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Education',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/education',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Entertainment',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/musicians-artists',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Media & Agency',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/media-agency',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Print',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/print',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Real Estate',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/realestate',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Retail',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/retail',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Sports',
          label_subtext: '',
          link: 'https://www.flowcode.com/sports',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Web3',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/web3',
          isExternal: false
        }
      ],
      columns: 3,
      label: 'Industries',
      link: 'https://www.flowcode.com/industry',
      isDense: true,
      isExternal: false
    },
    {
      items: [
        {
          fullWidth: true,
          label: 'Explore All',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'App Downloads',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-app-downloads',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Collecting CRM',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-crm',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Direct Mail',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-direct-mail',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Donations',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-donations',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Hiring employees',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-hiring',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'NFT sharing',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-sharing-nfts',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Open houses',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-open-houses',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Product packaging',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-product-packaging',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Sharing videos',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-sharing-videos',
          isExternal: false
        }
      ],
      columns: 3,
      label: 'Use Cases',
      link: 'https://www.flowcode.com/use-cases',
      isDense: true,
      isExternal: false
    },
    {
      items: [
        {
          fullWidth: false,
          label: 'Blog',
          label_subtext: 'Resources to grow your business',
          link: 'https://www.flowcode.com/blog',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Flowcode University',
          label_subtext: 'Courses and certifications',
          link: 'https://www.flowcode.com/flowcode-university',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Onboarding',
          label_subtext: 'Tips for setting up your account',
          link: 'https://www.flowcode.com/onboarding',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Help',
          label_subtext: 'Access the help center',
          link: 'https://help.flowcode.com/en/',
          isExternal: true
        },
        {
          fullWidth: false,
          label: 'Feature Releases',
          label_subtext: "See what's new",
          link: 'https://www.flowcode.com/feature-release-log',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Developer Portal',
          label_subtext: 'Flowcode API integrations',
          link: 'https://www.flowcode.com/developer-portal',
          isExternal: false
        }
      ],
      columns: 3,
      label: 'Resources',
      link: '',
      isDense: false,
      isExternal: true
    },
    {
      items: [
        {
          fullWidth: false,
          label: 'Enterprise',
          label_subtext: 'For companies',
          link: 'https://www.flowcode.com/enterprise',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Pro Plus',
          label_subtext: 'For professionals',
          link: 'https://www.flowcode.com/proplus',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Growth',
          label_subtext: 'For growing businesses',
          link: 'https://www.flowcode.com/growth',
          isExternal: false
        },
        {
          fullWidth: false,
          label: 'Pro',
          label_subtext: 'For individuals',
          link: 'https://www.flowcode.com/pro',
          isExternal: false
        }
      ],
      columns: 2,
      label: 'Plans',
      link: '',
      isDense: false,
      isExternal: false
    },
    {
      items: [],
      columns: 4,
      label: 'Pricing',
      link: 'https://www.flowcode.com/plans',
      isDense: true,
      isExternal: false
    }
  ],
  mobile: [
    {
      items: [
        {
          label: 'Flowcode',
          label_subtext: 'Free QR code generator',
          link: 'https://www.flowcode.com/free-qr-code-generator',
          isExternal: false
        },
        {
          label: 'Flowlytics',
          label_subtext: 'Measure performance, gain insights',
          link: 'https://www.flowcode.com/flowcode-insights',
          isExternal: false
        },
        {
          label: 'Flowpage',
          label_subtext: 'Mobile-first landing pages',
          link: 'https://www.flowcode.com/page',
          isExternal: false
        },
        {
          label: 'Flowtag',
          label_subtext: 'Easily share your contact info in real life',
          link: 'https://www.flowcode.com/flowtag',
          isExternal: false
        },
        {
          label: 'FlowcodeTV',
          label_subtext: 'Make any video interactive',
          link: 'https://www.flowcode.com/industry/tv',
          isExternal: false
        },
        {
          label: 'Flowcode Pixel ',
          label_subtext: 'Measure the ROI of your offline campaigns',
          link: 'https://www.flowcode.com/tools/flowcode-pixel',
          isExternal: false
        }
      ],
      label: 'Products',
      link: '',
      isExternal: false
    },
    {
      items: [
        {
          label: 'Explore All',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry',
          isExternal: false
        },
        {
          label: 'CPG',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/cpg',
          isExternal: true
        },
        {
          label: 'Education',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/education',
          isExternal: true
        },
        {
          label: 'Entertainment',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/musicians-artists',
          isExternal: false
        },
        {
          label: 'Media & Agency',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/media-agency',
          isExternal: false
        },
        {
          label: 'Print',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/print',
          isExternal: false
        },
        {
          label: 'Real Estate',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/realestate',
          isExternal: true
        },
        {
          label: 'Retail',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/retail',
          isExternal: true
        },
        {
          label: 'Sports',
          label_subtext: '',
          link: 'https://www.flowcode.com/sports',
          isExternal: false
        },
        {
          label: 'Web3',
          label_subtext: '',
          link: 'https://www.flowcode.com/industry/web3',
          isExternal: true
        }
      ],
      label: 'Industries',
      link: '',
      isExternal: false
    },
    {
      items: [
        {
          label: 'Explore All',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases',
          isExternal: false
        },
        {
          label: 'App Downloads',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-app-downloads',
          isExternal: false
        },
        {
          label: 'Collecting CRM',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-crm',
          isExternal: false
        },
        {
          label: 'Direct mail',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-direct-mail',
          isExternal: false
        },
        {
          label: 'Donations',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-donations',
          isExternal: false
        },
        {
          label: 'Hiring employees',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-hiring',
          isExternal: false
        },
        {
          label: 'NFT sharing',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-sharing-nfts',
          isExternal: false
        },
        {
          label: 'Open Houses',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-open-houses',
          isExternal: false
        },
        {
          label: 'Product Packaging',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-product-packaging',
          isExternal: false
        },
        {
          label: 'Sharing Videos',
          label_subtext: '',
          link: 'https://www.flowcode.com/use-cases/qr-codes-for-sharing-videos',
          isExternal: false
        }
      ],
      label: 'Use Cases',
      link: '',
      isExternal: false
    },
    {
      items: [
        {
          label: 'Blog',
          label_subtext: 'Resources to grow your business',
          link: 'https://www.flowcode.com/blog',
          isExternal: false
        },
        {
          label: 'Flowcode University',
          label_subtext: 'Courses and certifications',
          link: 'https://www.flowcode.com/flowcode-university',
          isExternal: false
        },
        {
          label: 'Help',
          label_subtext: 'Access the help center',
          link: 'https://help.flowcode.com/en/',
          isExternal: false
        },
        {
          label: 'Onboarding',
          label_subtext: 'Tips for setting up your account',
          link: 'https://www.flowcode.com/onboarding',
          isExternal: false
        },
        {
          label: 'Feature Releases',
          label_subtext: "See what's new",
          link: 'https://www.flowcode.com/feature-release-log',
          isExternal: false
        },
        {
          label: 'Developer Portal ',
          label_subtext: 'Flowcode API integrations',
          link: 'https://www.flowcode.com/developer-portal',
          isExternal: false
        }
      ],
      label: 'Resources',
      link: '',
      isExternal: true
    },
    {
      items: [
        {
          label: 'Enterprise',
          label_subtext: 'For companies',
          link: 'https://www.flowcode.com/enterprise',
          isExternal: false
        },
        {
          label: 'Growth',
          label_subtext: 'For growing businesses',
          link: 'https://www.flowcode.com/growth',
          isExternal: false
        },
        {
          label: 'Pro Plus',
          label_subtext: 'For professionals',
          link: 'https://www.flowcode.com/proplus',
          isExternal: false
        },
        {
          label: 'Pro',
          label_subtext: 'For individuals',
          link: 'https://www.flowcode.com/pro',
          isExternal: false
        }
      ],
      label: 'Plans',
      link: '',
      isExternal: false
    },
    {
      items: [],
      label: 'Pricing',
      link: 'https://www.flowcode.com/plans',
      isExternal: false
    }
  ]
}
